import { Box,Text } from "@chakra-ui/react";

export function Companies(){
    return <Box>
        <Text fontSize="lg">Companies</Text>
    </Box>
}